import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a9 9 0 0 0-9 9c0 4.971 4.029 9 9 9s9-4.029 9-9a9 9 0 0 0-9-9zm7.77 8.4h-2.8c-.136-2.854-1.214-5.345-2.821-6.892A7.807 7.807 0 0 1 16.77 8.4zM9.6 16.221V9.6h3.166c-.153 2.949-1.403 5.444-3.166 6.621zm0-7.821V1.779c1.763 1.177 3.013 3.672 3.166 6.622H9.6zM1.23 9.6h4.321l-2.4 2.4h1.697l3.001-3-3.001-3H3.151l2.4 2.4H1.23A7.803 7.803 0 0 1 8.4 1.23v15.54A7.804 7.804 0 0 1 1.23 9.6zm9.919 6.892c1.607-1.547 2.685-4.038 2.821-6.892h2.8a7.809 7.809 0 0 1-5.621 6.892z" />
  </svg>
);

export default SvgComponent;
